



























import Vue from "vue";
import Component from "vue-class-component";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BaseFlexForm from "@/components/BaseFlexForm.vue";
import { BaseViewRows, FormFields, FormValues } from "@/types";
import { namespace } from "vuex-class";
import { Prop } from "vue-property-decorator";
import { ACTION_TYPES } from "@/lib/const";
import { StateTags } from "@/store/types";
import BlockBaseViewText from "@/components/BlockBaseViewText.vue";
import { $t } from "@/lib/helpers/i18nHelper";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";
import { QuestionaryInfo } from "@teacherskaya/api-provider/dist/api/QuestionaryInfoProvider";
import providers from "@/lib/providers";

const { GET_DATA } = ACTION_TYPES;
const storePathTags = "tags";
const StoreTags = namespace(storePathTags);

@Component({
  name: "BlockUserTags",
  components: {
    BlockBaseViewText,
    BlockBaseForm,
    BlockBase,
    BaseFlexForm,
  },
})
export default class BlockUserTags extends Vue {
  @Prop({ type: Object, default: true })
  public readonly user!: User;

  @StoreTags.State((state: StateTags) => state.tags)
  public systemTags!: TagInfo[];

  @StoreTags.Action(GET_DATA)
  public getSystemTags!: () => Promise<void>;

  public questionaryInformation: QuestionaryInfo | null = null;

  public editing: boolean = false;

  private localValues: FormValues = {};

  get fields(): FormFields {
    const values = (this.questionaryInformation?.fields as { tags: number[] }).tags || [];
    return this.systemTags.reduce((out, item) => {
      const value = values.find(id => id.toString() === item.id);
      out.push({
        title: item.title,
        name: item.id,
        type: "checkbox",
        value: value ? value.toString() : "",
      });
      return out;
    }, [] as FormFields);
  }

  get values(): FormValues {
    if (this.editing) return this.localValues;
    this.localValues = {
      ...this.fields.reduce((out, item) => {
        out[item.name] = item.value || null;
        return out;
      }, {} as FormValues),
    };
    return this.localValues;
  }

  get checkedFields(): FormFields {
    return this.fields.filter(field => !!field.value);
  }

  get uncheckedFields(): FormFields {
    return this.fields.filter(field => !field.value);
  }

  get emptyFields(): boolean {
    return this.fields.length === 0;
  }

  get rows(): BaseViewRows {
    return this.checkedFields.reduce((out, item) => {
      out.push({
        fields: [$t(item.title || "")],
      });
      return out;
    }, [] as BaseViewRows);
  }

  get userId() {
    return this.user.id;
  }

  public async save(values: FormValues) {
    const data: FormValues = { ...this.localValues, ...values };
    const requestData: number[] = Object.keys(data).reduce((out, item) => {
      if (!!data[item] && !isNaN(Number(item))) out.push(Number(item));
      return out;
    }, [] as number[]);
    this.questionaryInformation = await providers.QuestionaryInfoProvider.update({
      data: { fields: { userId: this.userId, tags: requestData } },
    });
    this.editing = false;
  }

  public getData() {
    providers.QuestionaryInfoProvider.find({ id: this.userId })
        .then((r: QuestionaryInfo) => (this.questionaryInformation = r));
    this.getSystemTags();
  }

  private created(): void {
    this.getData();
  }
}
